export default "__VITE_ASSET__CSYLk48F__"